angular.module('tf.services')

    .factory('WebSocketService', ['$cookies','$rootScope','$state','$window','AUTH_EVENTS','$q', 'NotificationService',
            function ($cookies, $rootScope, $state, $window, AUTH_EVENTS, $q, NotificationService) {
        var wss = {};

        var pingpong;
        var host = location.origin.replace(/^http/, 'ws');

        wss.attempts = 0;
        wss.handlers = {};

        wss.ready=$q.defer();

        wss.whenReady=function(){
            return this.ready.promise;
        };

        wss.createWS = function(token){
            var defer = $q.defer();
            setReconnectionToken(token);
            wss.ws = new WebSocket(host);

            wss.ws.onopen = function(message) {
                //console.log("WS OPEN: ", message);
                wss.attempts = 1;
                authenticate(token);
                $rootScope.$broadcast('ws-open');
                defer.resolve();
                wss.ready.resolve();
            };
            wss.ws.onclose = function(message) {
                //console.log("WS CLOSE: ", message);
                clearInterval(pingpong);
                if(message.code == 1006 || message.code == 1001){
                    reconnect(wss.attempts);
                }
            };
            wss.ws.onerror = function(message) {
                //console.log("WS ERROR: ", message);
                defer.reject();
                wss.ready.reject();
            };


            wss.ws.onmessage = function (event) {
                var message = JSON.parse(event.data);
                var handler = wss.handlers[message.name];
                if(handler){
                    handler(message);
                } else {
                    console.log(message);
                }
            };
            return defer.promise;
        };


        wss.on = function(name, handler){
            wss.handlers[name] = handler;
        };
        wss.send = function(name, type, cid, data){
            var message = {name: name, type: type, cid: cid};
            if(data) message.data = data;
            wss.whenReady().then(function(){
                wss.ws.send(JSON.stringify(message));
            });
        };
        wss.subscribe = function(cid, payload){
            var message = {name: "subscribe", cid: cid};
            if(payload){
                message.payload = payload;
            }
            wss.whenReady().then(function() {
                wss.ws.send(JSON.stringify(message));
            });
        };
        wss.subscribePublic = function (id) {
            var message = {name: "subscribePublic", id: id};
            wss.whenReady().then(function() {
                wss.ws.send(JSON.stringify(message));
            });
        };
        wss.subscribeFarmPublic = function (id) {
            var message = {name: "subscribePublic", id: id, decrypted: true};
            wss.whenReady().then(function() {
                wss.ws.send(JSON.stringify(message));
            });
        };
        wss.close = function(){
            wss.ws.close();
        };

        wss.on("authenticated", startPinging);
        wss.on("pong", handlePong);
        wss.on("farmerConnected", farmerConnected);
        wss.on("farmerDisconnected", farmerDisconnected);
        wss.on("start", handleStart);
        wss.on("progress", handleProgress);
        wss.on("complete", handleComplete);
        wss.on("status", handleStatus);
        wss.on("preview", handlePreview);
        wss.on("tasks", handleTasks);
        wss.on("alert", handleAlert);
        wss.on("popup", handlePopup);
        wss.on("unsubscribe", handleUnsubscribe);
        wss.on("converting", handleConverting);
        wss.on("converted", handleConverted);
        wss.on("farmSettings", handleFarmSettings);

        function authenticate(token){
            var reconnectionToken = token || wss.reconnectionToken;
            wss.ws.send(JSON.stringify({name: 'authenticate', token: reconnectionToken? reconnectionToken : $cookies.get('access_token')}));
        }
        function startPinging(){
            pingpong = setInterval(function(){
                wss.ws.send(JSON.stringify({name: 'ping', token: $cookies.get('access_token')}));
            },10000);
        }
        function generateInterval (k) {
            return Math.random() * Math.min(15, (Math.pow(1.5, Math.min(k, 10)) - 1)) * 1000;
        }
        function reconnect(attempts){
            var time = generateInterval(attempts);
            setTimeout(function () {
                wss.attempts++;
                wss.createWS();
            }, time);
        }
        function setReconnectionToken(token){
            if(token){
                wss.reconnectionToken = token;
            }
        }
        function handlePong(message){
            if(!message.verified){
                $window.onbeforeunload = null;
                $rootScope.$broadcast(AUTH_EVENTS.sessionTimeout);
                if($cookies.get('access_token') !== 'timed out'){
                    $cookies.put('access_token', 'timed out');
                    // $state.go("home");
                    $window.location.href = 'login';
                }
            }
        }
        function farmerConnected(message){
            // console.log("Farmer " + message.cid + " has connected");
            wss.subscribePublic(message.cid);
        }
        function farmerDisconnected(message){
            //console.log("Farmer " + message.cid + " has disconnected");
        }
        function handleStart(message){
            $rootScope.$broadcast("start");
        }
        function handleProgress(message){
            $rootScope.$broadcast("progress", message);
        }
        function handleComplete(message){
            $rootScope.$broadcast("complete",message.data);
        }
        function handleStatus(message){
            $rootScope.$broadcast("status", message);
        }
        function handlePreview(message){
            $rootScope.$broadcast(message.cid, message.data);
        }
        function handleTasks(message){
            $rootScope.$broadcast("tasks", message.data);
        }
        function handleAlert(message){
            NotificationService.notify(message.data.type, message.data.params, message.data.options);
        }
        function handlePopup(message){
            NotificationService.popup(message.data.type, message.data.params, message.data.options);
        }
        function handleUnsubscribe(message){

        }
        function handleConverting(message){
            //console.log('converting');
            $rootScope.$broadcast('converting', message.data);
        }
        function handleConverted(message){
            //console.log('converted');
            $rootScope.$broadcast('converted', message.data);
        }
        function handleFarmSettings(message){
            $rootScope.$broadcast('farmSettings', message.args);
        }
        return wss;
    }])
;


